import { createRouter, createWebHistory } from 'vue-router';

const ReceiptPage = () => import('@/pages/receipt/index.vue');
const PersonalLinkPage = () => import('@/pages/personal-link/PersonalLink.vue');
const Error404Page = () => import('@/components/error/Error404.vue');
const ReceiptPageTest = () => import('@/pages/receipt/test.vue');
const Links = () => import('@/pages/links/index.vue');

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { name: 'receipt', path: '/receipt/:id', component: ReceiptPage, props: true },
    { name: 'receiptTest', path: '/receipt/test/:id', component: ReceiptPageTest, props: true },
    { name: 'links', path: '/:id(\\d+)', component: Links, props: true },
    { name: 'personalLink', path: '/:id([a-zA-Z0-9@.]+.*)', component: PersonalLinkPage, props: true },
    { path: '/:notFound(.*)', component: Error404Page },
  ],
});

export default router;
